import React from 'react';
import { Grid, TextField, FormControl } from '@mui/material';
import { FormSection, SectionTitle, FieldRow, FieldTitle } from './StyledComponents';
import CustomDatePicker from '../../../Widgets/CustomDates/CustomDatePicker/CustomDatePicker.js';

const ImportManifestDetailsSection = ({
    direction,
    t,
    formData,
    handleInputChange,
    validationErrors
}) => {
    return (
        <FormSection>
            <SectionTitle dir={direction}>{t('ImportManifestDetails')}</SectionTitle>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('ManifestNumber')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            value={formData.manifestNumber}
                            onChange={(e) => handleInputChange('manifestNumber', e.target.value)}
                            error={!!validationErrors.manifestNumber}
                            helperText={validationErrors.manifestNumber}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('ManifestDate')}</FieldTitle>
                        <FormControl
                            fullWidth
                            variant="standard"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: '8px',
                                background: '#F5F5F6',
                                border: '1px solid transparent',
                            }}
                        >
                            <CustomDatePicker
                                date={formData.manifestDate ? formData.manifestDate : null}
                                onDateChange={(date) => handleInputChange('manifestDate', date)}
                                height="42px"
                                error={!!validationErrors.manifestDate}
                                helperText={validationErrors.manifestDate}
                            />
                        </FormControl>
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('CustomsPurchaseTax')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.customsPurchaseTax}
                            onChange={(e) => handleInputChange('customsPurchaseTax', e.target.value)}
                            error={!!validationErrors.customsPurchaseTax}
                            helperText={validationErrors.customsPurchaseTax}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('ImportManifestVAT')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.importManifestVat}
                            onChange={(e) => handleInputChange('importManifestVat', e.target.value)}
                            error={!!validationErrors.importManifestVat}
                            helperText={validationErrors.importManifestVat}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('ComputerFee')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.computerFee}
                            onChange={(e) => handleInputChange('computerFee', e.target.value)}
                            error={!!validationErrors.computerFee}
                            helperText={validationErrors.computerFee}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('SecurityCheckFee')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.securityCheckFee}
                            onChange={(e) => handleInputChange('securityCheckFee', e.target.value)}
                            error={!!validationErrors.securityCheckFee}
                            helperText={validationErrors.securityCheckFee}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('VariousFees')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.variousFees}
                            onChange={(e) => handleInputChange('variousFees', e.target.value)}
                            error={!!validationErrors.variousFees}
                            helperText={validationErrors.variousFees}
                        />
                    </FieldRow>
                </Grid>
                <Grid item xs={12}>
                    <FieldRow dir={direction}>
                        <FieldTitle dir={direction}>{t('TotalManifest')}</FieldTitle>
                        <TextField
                            dir={direction}
                            size="small"
                            sx={{ flex: 1 }}
                            type="number"
                            value={formData.totalManifest}
                            onChange={(e) => handleInputChange('totalManifest', e.target.value)}
                            error={!!validationErrors.totalManifest}
                            helperText={validationErrors.totalManifest}
                        />
                    </FieldRow>
                </Grid>
            </Grid>
        </FormSection>
    );
};

export default ImportManifestDetailsSection;